/** jsxImportSource theme-ui */
import styled from '@emotion/styled'
import { useBreakpointIndex } from '@theme-ui/match-media'
import smallButton from 'assets/images/button-small.png'
import { Centered } from 'components/Flex'
import { Text } from 'theme-ui'

interface Props {
  quantity: number
}

const QuantityBadgeContainer = styled.div`
  width: 135px;
  height: 86px;
  background: url(${smallButton});
  background-size: contain;
`

const SmallQuantityBadgeContainer = styled(QuantityBadgeContainer)`
  width: calc(135px * 0.5);
  height: calc(86px * 0.5);
`

const QuantityBadge = ({ quantity }: Props) => {
  const index = useBreakpointIndex()
  return index > 2 ? (
    <QuantityBadgeContainer>
      <Centered>
        <Text sx={{ mb: 2, fontSize: 3 }}>{quantity}</Text>
      </Centered>
    </QuantityBadgeContainer>
  ) : (
    <SmallQuantityBadgeContainer>
      <Centered>
        <Text sx={{ mb: 2, fontSize: 2 }}>{quantity}</Text>
      </Centered>
    </SmallQuantityBadgeContainer>
  )
}

export default QuantityBadge
